import { TableHead } from './table';
import { ChevronUp, ChevronDown } from 'lucide-react';

/**
 * A TableHead that supports click-to-sort with direction indicator.
 *
 * @param {string} sortKey - The column key passed to requestSort
 * @param {function} requestSort - From useSortableTable
 * @param {function} getSortDirection - From useSortableTable
 * @param {string} className - Additional classes
 * @param {React.ReactNode} children - Column label
 * @param {boolean} sortable - Whether this column is sortable (default true)
 */
export function SortableTableHead({
  sortKey,
  requestSort,
  getSortDirection,
  className = '',
  children,
  sortable = true,
  ...props
}) {
  const direction = getSortDirection(sortKey);

  if (!sortable) {
    return <TableHead className={className} {...props}>{children}</TableHead>;
  }

  return (
    <TableHead
      className={`${className} cursor-pointer select-none hover:text-foreground transition-colors`}
      onClick={() => requestSort(sortKey)}
      data-testid={`sort-header-${sortKey}`}
      {...props}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {direction === 'asc' && <ChevronUp className="h-3 w-3 text-[#ffd108]" />}
        {direction === 'desc' && <ChevronDown className="h-3 w-3 text-[#ffd108]" />}
      </span>
    </TableHead>
  );
}
